import {
    ChartJsDoughnut,
    type ChartJsDoughnutDataType,
    ReactGridContainer,
} from '@europrocurement/flexy-components';

import React, { useEffect, useState } from 'react';
import { type ResizeHandleAxis } from 'react-grid-layout';
import { type DossierOpenSearchJsonldOpensearchDossierStatutRead } from '@europrocurement/l2d-domain/openApi/ApiFormalite';
import { Box, lighten, useTheme } from '@mui/material';
import { useStatusStyle } from '@europrocurement/l2d-modules/hooks';
import TasksDashboardWidget from '../TasksDashboardWidget/TasksDashboardWidget';

type TasksAndChartWidgetDashboardProps = {
    statusDossierOpenSearch?: DossierOpenSearchJsonldOpensearchDossierStatutRead[];
    formalistIds: number[];
};
const TasksAndChartWidgetDashboard: React.FunctionComponent<TasksAndChartWidgetDashboardProps> =
    function ({ statusDossierOpenSearch, formalistIds }) {
        const { palette } = useTheme();
        const { getDossierStatusStyle } = useStatusStyle();
        const [chartData, setChartData] = useState<ChartJsDoughnutDataType>();
        const availableHandles: ResizeHandleAxis[] = ['s', 'w', 'e', 'n', 'sw', 'nw', 'se', 'ne'];

        useEffect(() => {
            if (statusDossierOpenSearch) {
                const newChartData: ChartJsDoughnutDataType = {
                    labels: [],
                    datasets: [
                        {
                            label: 'Nombre de dossiers',
                            data: [],
                            backgroundColor: [],
                            borderWidth: 1,
                        },
                    ],
                };

                statusDossierOpenSearch.map((status) => {
                    const { color } = getDossierStatusStyle(status.id as number);
                    newChartData.labels.push(status.libelle as string);
                    newChartData.datasets[0].data.push(status.childsCount as number);
                    newChartData.datasets[0].backgroundColor.push(lighten(color, 0.5));
                    return true;
                });
                setChartData(newChartData);
            }
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [statusDossierOpenSearch]);

        return (
            <ReactGridContainer
                localStorageName="grid-widgets-formalist"
                // Merged statusDossierLayout and chart JS layout
                layoutProps={[
                    {
                        i: 'list-tasks-formalist',
                        x: 0,
                        y: 0,
                        w: 4,
                        h: 8,
                        isResizable: true,
                        resizeHandles: availableHandles,
                    },
                    {
                        i: 'chartJs-donught-formalist',
                        x: 4,
                        y: 0,
                        w: 2,
                        h: 8,
                        isResizable: true,
                        resizeHandles: availableHandles,
                    },
                ]}
            >
                <Box key="chartJs-donught-formalist">
                    {chartData && (
                        <ChartJsDoughnut
                            key="chartJs-donught"
                            data={chartData}
                        />
                    )}
                </Box>

                <Box
                    key="list-tasks-formalist"
                    sx={{
                        background: palette.background.paper,
                        borderRadius: '8px',
                        padding: '0px 8px',
                    }}
                >
                    <TasksDashboardWidget formalistIds={formalistIds} />
                </Box>
            </ReactGridContainer>
        );
    };

export default TasksAndChartWidgetDashboard;
